<!-- #63 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ +$route.params.id === 0 ? "Add" : "Edit" }} a Carrier
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ +$route.params.id === 0 ? "Add" : "Edit" }}

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-form ref="form">
          <v-row class="pb-0">
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                v-model="carrierDetail.name"
                label="Carrier Name"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Carrier name is required.',
                ]"
                class="required pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                v-model="carrierDetail.carrier_code"
                label="Carrier code"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Carrier code is required.',
                ]"
                class="required pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="d-flex pb-0">
              <v-file-input
                v-model="fileInput"
                accept="image/png, image/jpeg"
                label="Logo"
                outlined
                class="pb-0"
              >
              </v-file-input>
              <!-- <img :src="logoUrl" alt="Logo" /> -->
            </v-col>

            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                label="Country"
                :items="allCountries"
                v-model="carrierDetail.country_code"
                :rules="[(v) => !!v || 'Country is required.']"
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                v-model="carrierDetail.website"
                type="url"
                placeholder="https://"
                label="Website URL"
                :rules="[(v) => (v && !!v.trim()) || 'Url is required']"
                class="required pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                label="Service"
                :items="allServiceTypes"
                v-model="carrierDetail.service_type"
                :rules="[(v) => !!v || 'Service is required.']"
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                label="Type of label"
                :items="addList.list_label_types"
                v-model="carrierDetail.label_type_id"
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'Label type is required.']"
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                label="Payment Mode"
                :items="paymentModes"
                v-model="carrierDetail.service_payment_type"
                :rules="[(v) => !!v || 'Payment mode is required.']"
                class="required pb-0"
                item-value="value"
                item-text="text"
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="4" class="pb-0">
              <v-select
                v-model="carrierDetail.tracking_service_mode"
                label="Tracking Service Mode"
                :items="allTrackingServiceModes"
                :rules="[(v) => !!v || 'Tracking service mode is required']"
                class="required pb-0"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" sm="6" class="pb-0">
              <v-select
                v-model="carrierDetail.service_mode"
                label="Environment"
                :items="allServiceModes"
                :rules="[(v) => !!v || 'Service code is required']"
                class="required pb-0"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                v-model="carrierDetail.ramco_client_id"
                label="Ramco Client Id"
                outlined
                class="pb-0"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              class="pb-0"
              v-if="$route.params.id > 0"
            >
              <v-text-field
                v-model="carrierDetail.identifier_token"
                label="Token"
                outlined
                class="pb-0"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2" class="pb-0">
              <v-switch
                v-model="carrierDetail.active"
                label="Status"
                :rules="[
                  (v) => (v !== '' && v !== null) || `Status is required.`,
                ]"
                class="required pb-0"
                outlined
              ></v-switch>
            </v-col>
            <v-col cols="12" md="2" sm="2" class="pb-0">
              <v-switch
                v-model="carrierDetail.physical_test"
                label="Test Flag"
                outlined
                class="pb-0"
              ></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="$route.params.id == 0"
          color="primary"
          @click="saveCarrier"
          :loading="loader"
          class="ma-2"
          >Save</v-btn
        >
        <v-btn
          v-if="$route.params.id > 0"
          color="primary"
          @click="save"
          :loading="loader"
          class="ma-2"
          >Update</v-btn
        >
        <v-btn
          v-if="$route.params.id !== 0"
          class="ml-3"
          color="error"
          @click="$router.push('/carriers')"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { countries, serviceModes } from "@/config/data";

export default {
  computed: {
    ...mapGetters(["labelTypes"]),
    allCountries() {
      return Object.keys(countries).map((i) => {
        return {
          text: countries[i],
          value: i,
        };
      });
    },
    allServiceModes() {
      return Object.keys(serviceModes).map((i) => {
        return {
          text: serviceModes[i],
          value: i,
        };
      });
    },
  },
  data: () => ({
    paymentModes: [
      {
        text: "COD",
        value: "COD",
      },
      {
        text: "Prepaid",
        value: "Prepaid",
      },
      {
        text: "COD & Prepaid",
        value: "COD,Prepaid",
      },
    ],

    carriers: [],
    editedIndex: -1,
    search: null,
    dialogConfirm: false,
    loader: false,
    statusLoader: false,
    remvLinehaul: false,
    carrierId: null,
    active: "",
    label_type_id: "",
    service_type: "",
    name: "",
    filtersArr: {},
    carrierForm: false,
    carrierDetail: {},
    saveLoader: false,
    fileInput: null,
    logoUrl: null,
    addList: {},
    allServiceTypes: [],
    allTrackingServiceModes: [],
    statuses: [
      {
        text: "Active",
        value: "true",
      },
      {
        text: "Inactive",
        value: "false",
      },
    ],
  }),

  created() {
    this.fetchCarrierDetails();
    if (this.$route.params.id == 0) this.getAddCarrierList();
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getLabelTypes",
      "addCarriers",
      "getCarrierDetails",
      "updateCarrierDetails",
      "getAddCarrier",
    ]),
    allService() {
      this.allServiceTypes = Object.keys(this.addList.list_service_type).map(
        (i) => {
          return {
            text: this.capitalizeFirstLetter(i),
            value: i,
          };
        }
      );
      this.paymentModes = Object.keys(
        this.addList.list_service_payment_type
      ).map((i) => {
        return {
          text: this.addList.list_service_payment_type[i],
          value: i,
        };
      });
      this.allTrackingServiceModes = Object.keys(
        this.addList.list_tracking_service_mode
      ).map((i) => {
        return {
          text: this.addList.list_tracking_service_mode[i],
          value: i,
        };
      });
    },
    getAddCarrierList() {
      this.getAddCarrier().then((res) => {
        this.addList = res.data;
        this.allService();
      });
    },
    fetchCarrierDetails() {
      if (this.$route.params.id > 0) {
        this.loader = true;
        // this.$router.replace(`/carriers/edit/${this.$route.params.id}`);
        this.getCarrierDetails(this.$route.params.id)
          .then((res) => {
            this.loader = false;
            this.carrierDetail = res.data;
            this.carrierDetail.active = res.data.active;
            this.addList = res.data.drop_down_list;
            this.allService();
            this.logoUrl =
              "/images/logo/" + res.data.carrier_logo.split("/").pop();
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    collectFormData() {
      const payload = new FormData();
      for (const field in this.carrierDetail) {
        if (field === "logo") continue;
        payload.append(
          field,
          this.carrierDetail[field] === null ? "" : this.carrierDetail[field]
        );
      }
      if (this.fileInput) {
        payload.append("logo", this.fileInput);
        this.carrierDetail.logo = URL.createObjectURL(this.fileInput);
      }
      return payload;
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loader = true;
      this.updateCarrierDetails({
        id: this.$route.params.id,
        data: this.collectFormData(),
      })
        .then((res) => {
          this.loader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$emit("continue");
        })
        .catch(() => {
          this.loader = false;
        });
    },
    saveCarrier() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;

      this.addCarriers({
        data: this.collectFormData(),
      })
        .then((res) => {
          this.saveLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.carrierForm = false;
        })
        .catch(() => {
          this.saveLoader = false;
          this.carrierForm = false;
        });
    },
  },
};
</script>
